import { useMutation } from '@apollo/client';
import { Button, Modal } from 'antd';
import React from 'react';
import { ROUTES, TAB_KEYS } from '../../../../../../common/constants';
import useRouter from '../../../../../../common/useRouter';
import { DELETE_REGISTER } from '../../../../graphql/Mutation';

const DeleteRegisterModal = ({ showModal, setShowModal, registerData }) => {
  const {
    navigate,
    params: { projectId, registerId },
  } = useRouter();

  const [deleteRegister] = useMutation(DELETE_REGISTER, {
    fetchPolicy: 'network-only',
    onError() {},
    onCompleted() {
      navigate(`${ROUTES.PROJECTS}/${projectId}/${TAB_KEYS.REGISTER}`);
    },
  });

  const handleDelete = async () => {
    await deleteRegister({
      variables: {
        deleteRegisterId: registerId,
      },
    });
    setShowModal(false);
  };

  return (
    <Modal
      open={showModal}
      footer={false}
      centered
      maskClosable={false}
      closable={false}
    >
      <h2>Delete Register</h2>
      <p>
        Are you sure you want to delete this register with name
        <span className="ml-5">{registerData?.name}</span> ?
      </p>
      <div className="form-buttons">
        <Button
          shape="round"
          className="cancel-button"
          onClick={() => setShowModal(false)}
        >
          Cancel
        </Button>
        <Button
          shape="round"
          type="primary"
          className="save-button"
          onClick={handleDelete}
        >
          Delete
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteRegisterModal;
